import { GET_CLUB_REQUEST, LIST_CLUBS_REQUEST } from './constants';

export const listClubs = () => ({
  type: LIST_CLUBS_REQUEST
});

export const getClub = (slug, onError) => ({
  type: GET_CLUB_REQUEST,
  slug,
  onError
});
